import { render, staticRenderFns } from "./AllServiceForm.vue?vue&type=template&id=beb491ba&scoped=true&"
import script from "./AllServiceForm.vue?vue&type=script&lang=js&"
export * from "./AllServiceForm.vue?vue&type=script&lang=js&"
import style0 from "./AllServiceForm.vue?vue&type=style&index=0&id=beb491ba&prod&lang=scss&scoped=true&"
import style1 from "./AllServiceForm.vue?vue&type=style&index=1&id=beb491ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb491ba",
  null
  
)

export default component.exports